module.exports = __webpack_public_path__ + "img/YouTube_social_dark_circle_(2017).svg";